import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";

const OtpVerify = ({ onSubmit, onClose, onSubmitResend }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [resendLoading, setResendLoading] = useState(false);
  const { loading, error, user } = useSelector((state) => state.auth);
  const inputRefs = useRef([]);
  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (inputRefs.current[index - 1]) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    } else if (e.key === "ArrowLeft" && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleSubmit = () => {
    const fullOtp = otp.join("");
    onSubmit(fullOtp);
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    try {
      await onSubmitResend();
    } catch (err) {
      console.error("Resend OTP failed", err);
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm max-md:p-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold text-purple-600 mb-4 text-center">
          Enter OTP sent to Email
        </h2>
        <div className="flex justify-center gap-2 mb-4">
          {otp.map((data, index) => (
            <input
              key={index}
              maxLength="1"
              className="w-10 h-12 text-center border border-purple-600 rounded text-lg focus:outline-none"
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputRefs.current[index] = el)}
            />
          ))}
        </div>
        <button
          type="button"
          disabled={loading}
          onClick={handleSubmit}
          className={`w-full py-2 rounded transition text-white ${
            loading
              ? "bg-purple-400 cursor-not-allowed"
              : "bg-purple-600 hover:bg-purple-700"
          }`}
        >
          {loading ? "Verifying OTP..." : "Verify"}
        </button>
        <button
          onClick={handleResendOtp}
          disabled={resendLoading}
          className="mt-3 w-full text-purple-600 hover:underline text-sm"
        >
          {resendLoading ? "Resending OTP..." : "Resend OTP"}
        </button>
        <button
          onClick={onClose}
          className="mt-3 w-full text-purple-600 hover:underline text-sm"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default OtpVerify;
